import React from "react";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "./Button";

const ProfileCard = ({
  coach_id,
  coach,
  user,
  defaultUserImage,
  Pic,
  ex_years,
  degree,
  $per_time,
  onClickFollow,
  likeButton,
  getBadgeColor,
  workExperience,
}) => {
  const {
    id,
    profile_pic,
    name,
    skills = [],
    coach_type,
    workexperience = 0,
    followers_count = 0,
    program = [],
    is_following = false,
  } = coach;

  return (
    <div className="w-full h-[25rem]">
      <NavLink
        to={user ? `/browse-coach/coach-details/${coach_id}` : "#"}
        onClick={(e) => {
          if (!user) {
            e.preventDefault();
            toast.error("Please login to do this action");
          }
        }}
        className="block h-full"
      >
        <div className="flex flex-col justify-between h-full overflow-hidden transition-shadow duration-300 bg-white border border-gray-100 shadow-md rounded-2xl hover:shadow-lg">
          <div className="relative flex flex-col items-center p-4 text-center">
            {/* Profile Image */}
            <div className="w-24 h-24 mb-3 overflow-hidden border-2 border-white rounded-full shadow-md">
              {profile_pic ? (
                <img
                  className="object-cover w-full h-full"
                  src={`${process.env.REACT_APP_COACH_PROFILE_FOLDER_PATH}${profile_pic}`}
                  alt={name}
                  onError={defaultUserImage}
                />
              ) : (
                <img
                  className="object-cover w-full h-full"
                  src={Pic}
                  alt="Default"
                />
              )}
            </div>

            {/* Coach Type Badge */}
            {coach_type && (
              <span
                className={`absolute top-2 right-2 px-2 py-1 rounded-full text-xs font-semibold ${getBadgeColor(
                  coach_type
                )}`}
              >
                {coach_type}
              </span>
            )}

            {/* Name and Skills */}
            <div className="w-full">
              <div
                onClick={!user ? likeButton : undefined}
                className="hover:no-underline"
              >
                <h3 className="mb-1 text-lg font-semibold text-gray-800">
                  {name}
                </h3>
              </div>

              <div className="flex flex-wrap justify-center gap-1 mb-2">
                {skills.map((skill, index) => (
                  <span
                    key={index}
                    className="px-2 py-1 text-xs font-normal capitalize bg-gray-100 rounded"
                  >
                    {skill ? skill.name : "Communication"}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Stats and Pricing */}
          <div className="flex flex-col justify-center px-4 py-3 overflow-hidden border-t border-gray-100 bg-gray-50">
            <div className="flex items-center justify-between mb-3 text-sm">
              <div className="flex items-center text-gray-600">
                <img src={ex_years} alt="Experience" className="w-8 h-6 mr-1" />
                <span className="font-medium">{workExperience}</span>
              </div>

              <div className="flex items-center text-gray-600">
                <img src={degree} alt="Followers" className="w-6 h-6 mr-1" />
                <span className="text-lg font-medium">
                  {followers_count || 0}
                </span>
              </div>

              <div className="flex items-center text-green-600">
                <img src={$per_time} alt="Price" className="w-6 h-6 mr-1" />
                <span className="font-semibold">
                  {program.length === 1
                    ? `$${program[0].price}`
                    : program.length > 1
                    ? `$${program[0].price} - $${
                        program[program.length - 1].price
                      }`
                    : ""}
                </span>
              </div>
            </div>

            {/* Follow Button */}
            <div className="mt-4">
              {!user ? (
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    onClickFollow("");
                  }}
                  className="w-full py-2 text-xs font-semibold text-white transition-colors duration-200 bg-[#0C4545] hover:bg-[#0c4545c2] rounded"
                >
                  FOLLOW
                </button>
              ) : (
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    onClickFollow(id);
                  }}
                  className={`w-full py-2 text-xs font-semibold rounded transition-colors duration-200 ${
                    is_following
                      ? "bg-gray-300 hover:bg-gray-400 text-gray-800"
                      : "bg-[#0C4545] hover:bg-[#0c4545c2] text-white"
                  }`}
                  text={is_following ? "UNFOLLOW" : "FOLLOW"}
                />
              )}
            </div>
          </div>
        </div>
      </NavLink>
    </div>
  );
};

export default ProfileCard;
